import React, { FC } from "react";
import {
  PushBuilderData,
  PushClickBehavior,
  PushPlatforms,
} from "pages/PushBuilder/PushBuilderContent";

interface PushPreviewProps {
  data: PushBuilderData;
}

const PushPreview: FC<PushPreviewProps> = ({ data }) => {
  // Show iOS variant (most readers will see the iOS visual style)
  const settings = data.settings[PushPlatforms.IOS];
  const showImage = !!settings.image;

  return (
    <div className="flex h-full w-full items-center justify-center bg-themed-background">
      <div
        className="relative overflow-hidden rounded-[36px] border border-themed-border shadow-md"
        style={{
          width: 320,
          height: 560,
          background:
            "linear-gradient(180deg, #1e3a8a 0%, #4c1d95 60%, #831843 100%)",
        }}
      >
        {/* status bar */}
        <div className="absolute top-0 left-0 right-0 h-7 flex items-center justify-between px-6 text-[10px] text-white/80 font-semibold">
          <span>9:41</span>
          <span>•••</span>
        </div>

        {/* lock screen time */}
        <div className="absolute top-12 left-0 right-0 text-center text-white">
          <div className="text-[12px] tracking-wide">Monday, May 12</div>
          <div className="text-[44px] font-light leading-none mt-1">9:41</div>
        </div>

        {/* Notification card */}
        <div
          className="absolute left-4 right-4 rounded-2xl bg-white/95 backdrop-blur-sm shadow"
          style={{ top: 180 }}
        >
          <div className="flex items-start gap-3 p-3">
            <div className="w-8 h-8 rounded-md bg-[#6366F1] flex items-center justify-center text-white text-[10px] font-bold flex-shrink-0">
              App
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-baseline justify-between gap-2">
                <div className="text-[13px] font-semibold text-[#111827] truncate">
                  {settings.title || "Notification title"}
                </div>
                <div className="text-[10px] text-[#6B7280] flex-shrink-0">
                  now
                </div>
              </div>
              <div className="text-[12px] text-[#374151] leading-snug mt-0.5">
                {settings.description || "Description preview shows here."}
              </div>
              {settings.clickBehavior.type === PushClickBehavior.REDIRECT_URL &&
                settings.clickBehavior.webURL && (
                  <div className="text-[10px] text-[#6366F1] mt-1 truncate">
                    {settings.clickBehavior.webURL}
                  </div>
                )}
            </div>
            {showImage && (
              <div className="w-10 h-10 rounded-md bg-[#E5E7EB] flex items-center justify-center text-[8px] text-[#9CA3AF] flex-shrink-0">
                img
              </div>
            )}
          </div>
          {settings.summary && (
            <div className="px-3 pb-3 -mt-1 text-[11px] text-[#6B7280] leading-snug border-t border-[#F3F4F6] pt-2">
              {settings.summary}
            </div>
          )}
        </div>

        {/* Hint line */}
        <div className="absolute bottom-4 left-0 right-0 text-center text-[10px] text-white/60">
          slide to unlock
        </div>
      </div>
    </div>
  );
};

export default PushPreview;
